import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import './AddGallery.css';
import NeighbourSidebar from "../../NeighbourSidebar";
import Header from "../../NeighbourHeaderAfterLogin";
import Footer from "../../FooterAfterLogin";
import Form from 'react-bootstrap/Form';
import { Link,useNavigate } from 'react-router-dom';
import {validategallery} from '../../../Utils/validate';


const AddGallery = () => {
    const navigate = useNavigate();

    const [inputs,setInputs] = useState({title:''});

    const [errors,setErrors] = useState({});

    useEffect(() => {
        document.title = `Add Gallery | Local Bells`;
        document.getElementById('bodywrap').className = 'neaddgal';
    }, []);


    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };


    const [images, setImages] = useState([]);

    // Handle files dropped or selected
    const handleFiles = (files) => {
        const imageFiles = Array.from(files).filter(file => file.type.startsWith('image/'));
        const newImages = imageFiles.map(file => ({
            file,
            url: URL.createObjectURL(file),
        }));
        setImages(prev => [...prev, ...newImages]);
    };

    // Handle drag events
    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const files = e.dataTransfer.files;
        handleFiles(files);
    };

    

    const handleDelete = (urlToRemove) => {
        setImages(prev => {
            const updated = prev.filter(img => img.url !== urlToRemove);
            URL.revokeObjectURL(urlToRemove); // Clean up memory
            return updated;
        });
    };

    const handleInputChangeimg = (e) => {
        handleFiles(e.target.files);
    };
    /* Start Value set */
    const handleInputChange = (event) => {
      event.persist();
      setInputs(inputs => ({...inputs, [event.target.name]: event.target.value}));       
    }
    /* End Value set */

  const handleSubmit = (e) => {
    e.preventDefault();
         const validationErrors = validategallery(inputs,images);
     const noErrors = Object.keys(validationErrors).length === 0;
        setErrors({});
        setErrors(validationErrors);
        
        if(noErrors){
            navigate('/neighbour/view-gallery');
        }
        
  };

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <Row className='addgel-top'>
                                    <Col md={7} lg={6} xl={5}>
                                        <div className='white-box'>
                                            <div className="d-flex align-items-start justify-content-between gap-3">
                                                <h3>Add Gallery</h3>
                                                <Link to="#" onClick={() => navigate(-1)} className='cross-up'>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid crosy" alt="wp" />
                                                </Link>
                                            </div>
                                            <h6>Nashik's Neighborhood Photo Gallery</h6>
                                            <Form onSubmit={handleSubmit}>
                                                <div className=''>
                                                    {/* Dropzone */}
                                                    <div
                                                        onDrop={handleDrop}
                                                        onDragOver={(e) => e.preventDefault()}
                                                        onDragEnter={(e) => e.preventDefault()}
                                                        className='gen-upload'
                                                    >
                                                        <input
                                                            type="file"
                                                            multiple
                                                            accept="image/*"
                                                            onChange={handleInputChangeimg}
                                                            id="fileInput"
                                                        />
                                                        <label htmlFor="fileInput">
                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/uploadicn.webp'} className="img-fluid" alt="uploadicn" />
                                                            <div>
                                                                <h6>Upload Image</h6>
                                                                <h6><span className='fw-600'>460 X 324</span> px</h6>
                                                            </div>
                                                        </label>
                                                        {/* <label htmlFor="fileInput">
                                                            <strong>Click to select</strong> or drag & drop images here
                                                        </label> */}
                                                    </div>
                                                    {errors.images && (<p className="text-danger">{errors.images}</p>)}
                                                    {/* Previews */}
                                                    <div className='gen-upload-preview'>
                                                        {images.map((img, index) => (
                                                            <div key={index} >
                                                                <img
                                                                    src={img.url}
                                                                    alt="preview"
                                                                />
                                                                <button
                                                                    onClick={() => handleDelete(img.url)}
                                                                    type='button'
                                                                >
                                                                    &times;
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className='d-none'>Title</Form.Label>
                                                    <Form.Control type="text" placeholder="Title" name="title" onChange={handleInputChange} value={inputs.title} />
                                                    {errors.title && (<p className="text-danger">{errors.title}</p>)}
                                                </Form.Group>
                                                <Button type="submit" className='blue-btn'>Add photo</Button>
                                            </Form>
                                        </div>
                                        <div className='gen-switch-box'>
                                            <div className=''>
                                                <h6>Submit Anonymous</h6>
                                                <Form.Check
                                                    type="switch"
                                                    id="subano"
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <div className='footer-main footer'>
                                    <Footer />                                
                                </div>                                
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default AddGallery;


